// extracted by mini-css-extract-plugin
module.exports = {"authContainer":"homepage_authContainer__2cOyY","langContainer":"homepage_langContainer__3D_Pb"};